<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Sandra Penny McCallum, the Australian-born author of this earthy autobiography, calls herself a global gypsy and murmurs jestfully of her current exile in the Algarve of Portugal, having left Australia 20 years ago. This wonderful time and place have inspired the need to write as a catharsis well overdue. This book was inspired by an exhilarating life story and an interest in pre-history, a fascination and study of aspects of the English Renaissance, and some incredible life stories.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3a4ff370